export default __webpack_public_path__ + "static/media/Home_Dark.c592223a.png";